import * as React from 'react';
import { twMerge } from 'tailwind-merge';

export type ButtonProps = {
  id?: string;
  component?: React.ElementType;
  disabled?: boolean;
  href?: string;
  className?: string;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const ButtonIcon = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function (props, ref) {
    const {
      id,
      component: Component = 'button',
      disabled = false,
      className,
      onClick = () => {},
      children,
      href,
    } = props;

    const classNames = twMerge(
      'flex flex-row justify-center font-bold py-2 px-2 rounded-full box-border text-sm font-normal',
      disabled ? 'cursor-not-allowed ' : 'active:bg-[#231D32]',
      className
    );

    const handleClick = disabled ? () => {} : onClick;

    return (
      <Component
        type='button'
        ref={ref}
        id={id}
        href={href}
        className={classNames}
        onClick={handleClick}
      >
        {children}
      </Component>
    );
  }
);
